"use client";

import { SLATE_XP_REDRAWN_ICONS_BETA } from "@faire/web/slate/icons/lib/SLATE_XP_REDRAWN_ICONS";

import {
  Chevron as ChevronControl,
  ChevronLeft as ChevronLeftControl,
  ChevronRight as ChevronRightControl,
  ChevronUp as ChevronUpControl,
  ChevronDown as ChevronDownControl,
} from "./__internal__/Chevron.control";
import {
  Chevron as ChevronTreatment,
  ChevronLeft as ChevronLeftTreatment,
  ChevronRight as ChevronRightTreatment,
  ChevronUp as ChevronUpTreatment,
  ChevronDown as ChevronDownTreatment,
} from "./__internal__/Chevron.treatment";

export const Chevron = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ChevronControl,
  treatment: ChevronTreatment,
});

/**
 * @deprecated use ChevronLeft from `@faire/slate/icons/ChevronLeft`
 * @trackcomponent
 */
export const ChevronLeft = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ChevronLeftControl,
  treatment: ChevronLeftTreatment,
});

/**
 * @deprecated use ChevronUp from `@faire/slate/icons/ChevronUp`
 * @trackcomponent
 */
export const ChevronUp = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ChevronUpControl,
  treatment: ChevronUpTreatment,
});

/**
 * @deprecated use ChevronDown from `@faire/slate/icons/ChevronDown`
 * @trackcomponent
 */
export const ChevronDown = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ChevronDownControl,
  treatment: ChevronDownTreatment,
});

/**
 * @deprecated use ChevronRight from `@faire/slate/icons/ChevronRight`
 * @trackcomponent
 */
export const ChevronRight = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ChevronRightControl,
  treatment: ChevronRightTreatment,
});
